
import { defineComponent } from 'vue';
import PrivacyPolicyTemplate from '@/components/templates/terms/PrivacyPolicyTemplate.vue';
import { useI18n } from '@/plugins/i18n';
import JaMessages from '@/assets/i18n/ja/terms/privacy_policy.json';
import EnMessages from '@/assets/i18n/en/terms/privacy_policy.json';
import { pageview } from 'vue-gtag';

export default defineComponent({
  name: 'PrivacyPolicy',
  components: { PrivacyPolicyTemplate },
  methods: {
    track() {
      pageview({ page_path: '/terms/privacy_policy' });
    },
  },
  setup() {
    const i18n = useI18n();
    i18n.$setMessages(JaMessages, EnMessages);

    return {
      i18n,
    };
  },
});
